import React from 'react';
import { Title, Body } from '@panwds/react-ui';

interface TabPageHeaderProps {
    title: string;
    description?: string;
    addClassName?: string;
    children?: React.ReactNode;
}

const TabPageHeader: React.FC<TabPageHeaderProps> = ({ title, description, addClassName, children }) => {
    return (
        <div className={addClassName}>
            <div className={children ? "tw-flex tw-items-center tw-gap-2" : undefined}>
                <Title level={2} size="xs">{title}</Title>
                {children}
            </div>
            {description && (
                <Body appearance="secondary" size="sm" addClassName="tw-mt-1">
                    {description}
                </Body>
            )}
        </div>
    );
};

export default TabPageHeader;
